import { Button } from "../../ui/button";
import Spinner from "../../spinner.components";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import { KycType } from "../../../types/models/kyc.types";

// Standard Approve Button Pattern
interface ApproveButtonProps {
  id: string;
  onSuccess: () => void;
  hook: any;
  paramName: string;
}

export function KycApproveButton({
  id,
  onSuccess,
  hook,
  paramName,
}: ApproveButtonProps) {
  const { toast } = useToast();
  const { execute, fetching } = hook();

  async function handleApprove() {
    const response = await execute({
      body: null,
      pathParams: { [paramName]: id },
    });

    if (response.success) {
      toast({ content: "Approved successfully", toastType: "success" });
      onSuccess();
    } else {
      handleHttpError(response, toast);
    }
  }

  return (
    <Button
      disabled={fetching}
      onClick={handleApprove}
      className="bg-approvebuttonbg disabled:opacity-50 border border-approvebuttonborder w-32 text-approvebuttontext"
    >
      {fetching ? <Spinner width={20} /> : "Approve"}
    </Button>
  );
}

// Standard Reject Button Pattern

interface RejectButtonProps {
  id: string;
  type: KycType;
}

export function KycRejectButton({ id, type }: RejectButtonProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query") || "";

  return (
    <Button
      onClick={() => {
        navigate(`${type}/${id}/reject${query ? `?query=${query}` : ""}`);
      }}
      className="bg-rejectbuttonbg border border-rejectbuttonborder w-32 text-rejectbuttontext"
    >
      Reject
    </Button>
  );
}
